import React, { useState, useEffect, useMemo } from 'react';
import { Platform, ScrollView, TouchableOpacity, View } from 'react-native'

import tw from '../styles/tailwind';
import Text from '../components/Text';





export default function TabsSelector({ onChange, options, pills = false, segmented = false, selectedValue }) {
  const [selected, setSelected] = useState(options[0].value);

  // Permite uso controlado: si llega selectedValue, el resaltado lo sigue.
  const current = selectedValue !== undefined ? selectedValue : selected

  function select(value) {
    setSelected(value)
    onChange?.(value)
  }

  // Variante "segmented": track gris con el tab activo como pill blanco (texto morado).
  // Para subtabs (Mora, y a futuro Cuotas/Gastos).
  if (segmented) {
    return (
      <View style={tw`row bg-[#EAEAEA] rounded-xl p-1`}>
        {
          options.map(option => {
            const isSelected = current === option.value
            return (
              <TouchableOpacity
                key={option.value}
                style={tw.style(`flex-1 items-center justify-center rounded-lg py-2`, isSelected && `bg-white shadow-sm`)}
                onPress={() => select(option.value)}
              >
                <Text style={tw.style(`text-sm`, isSelected ? `text-secondary font-600` : `text-gray-400 font-500`)}>{option.label}</Text>
              </TouchableOpacity>
            )
          })
        }
      </View>
    )
  }

  // Variante "pills": barra de fondo morado, tab seleccionado como pill blanco.
  if (pills) {
    const pillButtons = options.map(option => {
      const isSelected = current === option.value
      return (
        <TouchableOpacity
          key={option.value}
          style={tw.style(`rounded-full px-3 py-2 items-center justify-center`, isSelected && `bg-white`)}
          onPress={() => select(option.value)}
        >
          <Text style={tw.style(`text-sm`, isSelected ? `text-secondary font-600` : `text-white/80`)}>{option.label}</Text>
        </TouchableOpacity>
      )
    })

    // En web mostramos todas las pills en una fila repartida (sin scroll, con wrap
    // de respaldo si no cupieran). En nativo dejamos el scroll horizontal táctil.
    if (Platform.OS === "web") {
      return (
        <View style={tw`bg-secondary flex-row flex-wrap justify-around items-center p-1.5 gap-1`}>
          {pillButtons}
        </View>
      )
    }

    return (
      <View style={tw`bg-secondary`}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={tw.style(`p-1.5 gap-x-1 justify-around items-center`, { flexGrow: 1 })}
        >
          {pillButtons}
        </ScrollView>
      </View>
    )
  }

  function renderTab(label, value) {
    return (
      <TouchableOpacity
        key={value}
        style={tw.style(`bg-white items-center py-3.5 px-2`)}
        onPress={() => select(value)}
      >
        <Text style={tw.style(`text-gray-500 text-base`, current === value && `text-secondary font-500`)}>{label}</Text>
        {
          current === value &&
            <View style={tw`h-1 rounded-t-lg bg-secondary w-80% absolute -bottom-0`}></View>
        }
      </TouchableOpacity>
    )
  }

  

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={Platform.OS == "web"}
      style={tw`bg-white border-b border-secondary`}
      // flexGrow: 1 -> el contenido llena el ancho y los tabs se reparten (justify-around)
      // cuando caben; si se desbordan, el ScrollView permite scroll horizontal (web y nativo).
      contentContainerStyle={tw.style(`justify-around`, { flexGrow: 1 })}
    >
      {
        options.map(option => renderTab(option.label, option.value))
      }
    </ScrollView>
  )
}